import { Component, OnInit, Input } from '@angular/core';
import { Question, ReplyItem } from '../../../../../classes';
import { RepliesService } from '../../../../../services';
import { ChartsService } from '../../../charts.service';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { get } from 'lodash';
import { RepliesPerOptionService } from '../../../modals/replies-per-option/replies-per-option.service';

@Component({
  template: '',
})
export class QuestionComponent implements OnInit {
  @Input() question:Question;
  relatedReplyList:Observable<ReplyItem[]> = this.replies.list.pipe(
    map(list=>list.filter(li=>get(li, ['snapshot', this.question.id]))),
    shareReplay(1),
  )

  constructor(
    protected replies:RepliesService,
    protected charts:ChartsService,
    protected repliesPerOptionModal:RepliesPerOptionService,
  ) { 
    // this.statistics = this.createStatisticsObservable();
    // this.as = this.auth.as;
  }
  ngOnInit() {
  } 
}
